module.exports = __webpack_public_path__ + "static/assets/83a5765be12760143b7a04bda1799dc4.svg";